import { Route, Routes, Navigate } from 'react-router-dom';
import { Empty } from 'antd';
import Login from './auth/Login';
import RequireAuth from './auth/RequireAuth';
import AuthCallback from './auth/AuthCallBack';
import Layout from './pages/Layout';
import Analytics from './pages/Analytics';
import SplashScreen from './pages/SplashScreen';

function App() {
    return (
        <Routes>
            {/* Redirect to login by default */}
            <Route path="/" element={<Navigate to="/login" />} />
            
            {/* Login Route */}
            <Route path='/login' element={<Login />} />
            
            {/* Authentication callback route (if needed) */}
            <Route path='/auth/callback' element={<AuthCallback />} />
            
            {/* Protected Routes - only accessible after login */}
            <Route path='/' element={
                <RequireAuth>
                    <Layout />
                </RequireAuth>
            }>
                <Route path='analytics' element={<Analytics />} />
                <Route path='*' element={<Empty />} /> {/* Catch-all route for unknown paths */}
            </Route>
            
            {/* Splash screen if you want to have this available */}
            <Route path='/splash-screen' element={<SplashScreen />} />
        </Routes>
    );
}

export default App;
